<header>
  <section class="title-section">
    <div
      class="logo-title"
      (click)="
        isNavVisible.set(false);
        onRouterLinkClick.emit({ routerLink: '/', shouldDoViewportCheck: true })
      "
    >
      <div>
        <p class="text-2 text-light" style="font-style: italic">HTW</p>
      </div>
    </div>
    <div class="bars" (click)="toggleNav()">
      @if (isNavVisible()) {
        <fa-icon [icon]="faTimes" size="lg" style="font-size: 1.25rem"></fa-icon>
      } @else {
        <fa-icon [icon]="faBars" size="lg" style="font-size: 1.25rem"></fa-icon>
      }
    </div>
  </section>
  <section class="nav-section" [class.visible]="isNavVisible()">
    <ul>
      <li class="nav-link-container">
        <!-- <i class="pi pi-info-circle"></i> -->
        <a
          class="btn text-light"
          routerLink="/services"
          (click)="isNavVisible.set(false); onRouterLinkClick.emit({ routerLink: '/services' })"
          >Services</a
        >
      </li>
      <li class="nav-link-container">
        <a
          class="btn text-light"
          routerLink="/projects"
          (click)="isNavVisible.set(false); onRouterLinkClick.emit({ routerLink: '/projects' })"
          >Projects</a
        >
      </li>
      <li class="nav-link-container">
        <!-- <i class="pi pi-link"></i> -->
        <a
          class="btn text-light"
          routerLink="/contact"
          (click)="isNavVisible.set(false); onRouterLinkClick.emit({ routerLink: '/contact' })"
          >Contact</a
        >
      </li>
    </ul>
  </section>
</header>
